<a [routerLink]="
    '/p/' + generateURL(data.F001 || data.F002) + '/' + generateURL(data.C001)
  " [queryParams]="{
    subGroup: data.D001,
    filters: filtersParams
  }" class="c-productsList__itemCard" [id]="'card_'+data.C000" [attr.aria-label]="'Open item ' + data.F001">
  <!-- product image -->
  <div class="c-productsList__item-imageContainer">
    <span *ngIf="generalService.debugMode"> [F000] </span>
    <img [alt]="data.F001" [src]="generalService.resizeImage(data.F000, '-s')"
      class="c-productsList__item-image product-cover" />

    <span *ngIf="data.F027 && data.F027 === true"
      class="c-productsList__item-tag c-productsList__item-tag--new">Uutuus</span>
  </div>

  <!-- card detail -->
  <div class="c-productsList__item-body">
    <div class="c-productsList__item-meta">

      <div class="c-productsList__item-metaIcons">
        <div class="c-productsList__item-metaIconsGroup">
          <span *ngIf="data.F026 && data.F026 === true"
            class="c-productsList__item-tag c-productsList__item-tag--sale">Tarjous</span>

          <img *ngIf="data.F021 && data.F021 === true" class="c-productsList__item-metaIcon"
            src="assets/images/product/icons/frozen.svg" alt="Frozen" />

          <img *ngIf="data.F022 && data.F022 === true" class="c-productsList__item-metaIcon"
            src="assets/images/product/icons/vegan.svg" alt="Vegan" />

          <img *ngIf="data.F023 && data.F023 === true" class="c-productsList__item-metaIcon"
            src="assets/images/product/icons/gluten-free.svg" alt="Gluten free" />

          <img *ngIf="data.F024 && data.F024 === true" class="c-productsList__item-metaIcon"
            src="assets/images/product/icons/lactose-free.svg" alt="Lactose free" />
        </div>
      </div>
    </div>

    <!-- title -->
    <h3 class="c-productsList__item-title c-productsList__item-title--primary">
      <span *ngIf="generalService.debugMode"> [F001] </span>
      {{ data.F001 }}
    </h3>

    <h4 class="c-productsList__item-title c-productsList__item-title--secondary">
      <span *ngIf="generalService.debugMode"> [F002] </span>
      {{ data.F002 }}
    </h4>

    <div class="c-productsList__item-quantity">
      <span class="visuallyhidden">Quantity:</span>
      <span *ngIf="generalService.debugMode"> [F032] </span>
      <span *ngIf="data.F032" [innerHTML]="data.F032"></span>
    </div>

    <!-- marketing -->
    <div class="c-productsList__item-marketing">
      <span *ngIf="generalService.debugMode"> [F003] </span>
      {{ data.F003 }}
    </div>
  </div>

  <div class="c-productsList__item-extra">
    <div class="c-price c-price--byUnit c-productsList__item-price" [ngClass]="{
        ' c-price--hasDiscount': data.F007 ? true : false
      }">
      <span class="c-price-base c-productsList__item-price-base">{{
        price || "0"
        }}</span>
      <span class="c-price-sub c-productsList__item-price-sub">{{ subprice || "00" }}
        <span *ngIf="generalService.debugMode"> [F018] </span>
      </span>

      <div class="c-price-discount c-productsList__item-price-discount" *ngIf="data.F007">
        <span class="visuallyhidden">Discount: </span>
        <span *ngIf="generalService.debugMode"> [F007] </span>
        {{ data.F007 | number: "1.2-3" | shopCurrencyDigits }}
      </div>
      <div class="c-price-reference c-productsList__item-price-refrence">
        <span class="visuallyhidden">Reference:</span>
        <span *ngIf="generalService.debugMode"> [F033] </span>
        <span [innerHTML]="data.F033"></span>
      </div>
    </div>
  </div>


</a>

<sv-buy-btn [data]="data"></sv-buy-btn>

<div class="c-productsList__item-notes">
  <!--(bake-start _if="product.organic")-->
  <img *ngIf="data.F025 && data.F025 === true" class="c-productsList__item-noteIcon"
    src="assets/images/product/icons/organic-fi.svg" alt="Organic" />
  <!--(bake-end)-->
  <!--(bake-start _if="product.local")-->
  <img *ngIf="data.F028 && data.F028 === true" class="c-productsList__item-noteIcon"
    src="assets/images/product/icons/local-fi.svg" alt="Local" />
  <!--(bake-end)-->
</div>